import SpineWrapper from '@Core/Animation/SpineWrapper';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { TextContainer } from '@Core/TextContainer/TextContainer';
import { CURRENCY_TO_BITMAP_CHARACTERS } from '@Core/Utils/CurrencyCharacterUtils';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { GameScene } from '..';

export class StaticJackpotLadder {
    public static readonly STATIC_JACKPOT_LADDER_PLACEHOLDERS = [
        'mini_odometer_placeholer',
        'minor_odometer_placeholder',
        'major_odometer_placeholder',
        'mega_odometer_placeholder',
        'grand_odometer_placeholder',
        '10.000x_odometer_placeholder'
    ];
    private readonly textContainers: TextContainer[] = [];
    private readonly multipliers: number[] = [];
    constructor(
        private readonly scene: GameScene,
        spine: SpineWrapper,
        symbolId: number
    ) {
        const config = scene.gameStore
            .get(EGameStoreKeys.AuthenticateGameConfig)
            .symbols[0].find((symbolConfiguration) => symbolConfiguration.symbolId === symbolId);
        if (config?.roles?.at(0)?.paytable?.at(0)?.multiplier) this.multipliers = [...config.roles.at(0)!.paytable.at(0)!.multiplier];
        StaticJackpotLadder.STATIC_JACKPOT_LADDER_PLACEHOLDERS.forEach((placeholder, index) => {
            const multiplier = this.multipliers[index];
            const text = this.getText(this.getCurrentBet(), multiplier);
            this.textContainers.push(TextContainer.fromSlot(placeholder, scene, text));
            spine.slotManager.assignObjectToSlot(placeholder, this.textContainers[index]);
        });
        scene.game.gameStore.on(EGameStoreKeys.BetState, this.updateTexts, this);
    }

    private updateTexts() {
        this.textContainers.forEach((container, index) => {
            const multiplier = this.multipliers[index];
            container.setText(this.getText(this.getCurrentBet(), multiplier));
        });
    }

    private getText(bet: number, betMultiplier: number): string {
        const value = bet * betMultiplier;
        return CurrencyUtils.formatRawCurrencyValue(value, {
            symbol: `${String.fromCodePoint(CURRENCY_TO_BITMAP_CHARACTERS[CurrencyUtils.getCurrencyISO()])}`
        });
    }

    private getCurrentBet() {
        return this.scene.game.gameStore.get(EGameStoreKeys.BetState).value.raw;
    }
}
